<script>
import PropertyList from "@/components/widgets/property-selector.vue";
export default {
  components: {
    PropertyList,
  },
  data() {
    return {
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "name",
          sortable: true,
        },
        {
          key: "addressPosition",
        },
        {
          key: "contact",
        },
      ],
      properties: [],
      selectedCampus: this.$store.state.data.selectedCampus.id,
    };
  },
  methods: {
    fetchAllProperties() {
      this.$store.commit("client/SET_ENTITY_LIST_LOADING", true);
      this.$store
        .dispatch("client/getClientByType", {
          campusId: this.selectedCampus,
          type: "ppe",
        })
        .then((response) => {
          this.$store.commit("client/SET_ENTITY_LIST_LOADING", false);
          if (response.data.error) {
            return this.showToast(response.data.errorMessage, "error");
          }
          this.properties = response.data;
          this.totalRows = response.data.length;
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit("client/SET_ENTITY_LIST_LOADING", false);
          this.showToast("There was an error fetching suppliers", "error");
        });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    viewModal() {
      this.$bvModal.show("inventory-modal");
    },
  },
  created() {
    this.fetchAllProperties();
  },
};
</script>
<template>
  <div>
    <div class="row mt-1">
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_filter" class="dataTables_filter">
          <label class="d-inline-flex align-items-center">
            Search:
            <b-form-input
              autocomplete="off"
              v-model="filter"
              type="search"
              placeholder="Search..."
              class="form-control form-control-sm ms-2"
            ></b-form-input>
          </label>
        </div>
      </div>
      <div class="col-sm-12 col-md-6 text-start text-md-end mb-sm-2">
        <b-button size="sm" @click="viewModal" variant="outline-info">
          <i class="bx bxs-edit align-middle me-2"></i>
          <span class="align-middle">Update List</span>
        </b-button>
      </div>
    </div>
    <div class="table-responsive mb-0">
      <b-table
        class="datatables"
        :items="properties"
        :fields="fields"
        responsive="sm"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :filter="filter"
        :filter-included-fields="filterOn"
        :busy="$store.state.client.isEntityListLoading"
        @filtered="onFiltered"
        bordered
        hover
        show-empty
        select-mode="single"
        selectable
        @row-dblclicked="$emit('fetchprop', $event)"
      >
        <template #empty="scope">
          <div class="text-center">{{ scope.emptyText }}</div>
        </template>
        <template #table-busy>
          <div class="d-flex justify-content-center align-items-center">
            <div class="preloader-component me-2">
              <div class="status">
                <div class="spinner-chase w-20px h-20px">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
            <strong>Loading...</strong>
          </div>
        </template>
        <template #cell(name)="row">
          <span class="mb-0">{{ row.item.name }}</span> -
          <span class="badge rounded-pill bg-success">{{ row.item.type }}</span>
        </template>
        <template #cell(contact)="row">
          <p class="mb-0">
            <i class="bx bx-mail-send align-middle me-2"></i
            ><span class="text-warning">{{ row.item.email }}</span>
          </p>
          <p class="mb-0">
            <i class="bx bx-phone-call align-middle me-2"></i
            ><span class="text-info">{{ row.item.contactNumber }}</span>
          </p>
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
    <!-- Modal here... -->
    <b-modal
      title="Update Inventory List"
      size="xl"
      id="inventory-modal"
      hide-footer
      no-close-on-backdrop
      no-close-on-escape
      @hidden="fetchAllProperties"
    >
      <PropertyList />
    </b-modal>
    <!-- Modal here... -->
  </div>
</template>
